module.exports = __webpack_public_path__ + "img/108.8a3f9270.jpg";